module.exports = __webpack_public_path__ + "img/26.017f1c1b.jpg";